import React from "react";

const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://www.linkedin.com/in/artur-aghasafyants-4b4414230/"
        className="home__social-icon"
        target="_blank"
      >
         <i class="uil-linkedin-alt"></i>
      </a>

      <a
        href="https://t.me/+33767638038"
        className="home__social-icon"
        target="_blank"
      >
        <i class="uil uil-telegram-alt"></i>
      </a>

      <a
        href="https://github.com/r2r90"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-github-alt"></i>
      </a>
    </div>
  );
};

export default Social;
